import React, { useEffect, useState } from 'react';
import {
  Container,
  Title,
  Table,
  SelectTabWrapper,
  SelectedTab
} from './styled';
import { toJS } from 'mobx';

const PlayerGameStat = ({ data, gameData }) => {
  const [selectPosition, setSelectPosition] = useState('home');
  const [viewList, setViewList] = useState([]);

  useEffect(() => {
    setViewList(data.home.additionalTeamData);
  }, []);

  const teamData = gameData.detail.getTeamData;
  const handleChangePosition = (position) => {
    setSelectPosition(position);
    setViewList(data[[position]].additionalTeamData);
  };
  if (data === null) {
    return null;
  } else {
    return (
      <Container>
        <Title>개인기록</Title>

        <SelectTabWrapper>
          <SelectedTab
            isSelected={selectPosition === 'home'}
            onClick={() => handleChangePosition('home')}
          >
            {teamData && teamData.home.name} (홈)
          </SelectedTab>
          <SelectedTab
            isSelected={selectPosition === 'away'}
            onClick={() => handleChangePosition('away')}
          >
            {teamData && teamData.away.name} (원정)
          </SelectedTab>
        </SelectTabWrapper>
        <Table>
          <colgroup>
            <col width={150} />
            <col width={70} />
            <col width={70} />
            <col width={70} />
            <col width={70} />
            <col width={70} />
            <col width={70} />
            <col width={70} />
          </colgroup>
          <thead>
            <tr>
              <th></th>
              <th>포지션</th>
              <th>출장시간</th>
              <th>득점</th>
              <th>어시스트</th>
              <th>리바운드</th>
              <th>스틸</th>
              <th>블록</th>
            </tr>
          </thead>
          <tbody>
            {viewList.map((value, key) => (
              <StatRow key={key} data={value} />
            ))}
          </tbody>
        </Table>
      </Container>
    );
  }
};

const StatRow = ({ data }) => {
  const {
    player,
    timesPlayed,
    points,
    assists,
    reboundsTotal,
    steals,
    blockedShots
  } = data;
  return (
    <tr>
      <td>{player.displayName}</td>
      <td>{player.position}</td>
      <td>{timesPlayed}</td>
      <td>{points}</td>
      <td>{assists}</td>
      <td>{reboundsTotal}</td>
      <td>{steals}</td>
      <td>{blockedShots}</td>
    </tr>
  );
};

export default PlayerGameStat;
